import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityFollowButton } from "~/components/entity-follow-button";
import { MyNewsPromotionWidget } from "~/components/my-news/my-news-promotion-widget";
import { TopicLink } from "~/components/topic/topic-link";

export const StyledTopicLink = styled(TopicLink)``;

export const Divider = styled.div`
  inline-size: 1px;
  block-size: 15px;
  margin-inline: 12px;

  background: #ffffff;
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)``;

export const StyledMyNewsPromotionWidget = styled(MyNewsPromotionWidget)``;

export type StyledProps = {
  $variant: "stack" | "banner";
};
export const Container = styled.div<StyledProps>`
  ${props => {
    switch (props.$variant) {
      case "banner":
        return css`
          display: flex;
          align-items: center;

          min-block-size: 40px;
          padding-block: 10px;
          padding-inline: 12px;

          background: #ffca05;

          ${StyledTopicLink} {
            margin-inline-end: auto;

            color: #000000;
            font-weight: 700;
            font-size: 16px;
            font-family: ${fontRobotoCondensed};
            line-height: 19px;

            :hover {
              color: #2c4692;
            }

            ${props.theme.breakpoints.up("tablet")} {
              font-size: 19px;
            }
          }

          ${Divider} {
            flex: none;
          }

          ${Divider}:last-child {
            display: none;
          }

          ${props.theme.breakpoints.up("tablet")} {
            inline-size: min-content;

            white-space: nowrap;
          }
        `;
      case "stack":
        return css`
          display: flex;
          flex-flow: column nowrap;
          align-items: flex-start;

          ${StyledTopicLink} {
            color: #000000;
            font-size: 16px;
            font-family: ${fontRobotoCondensed};
            line-height: 16px;
          }

          ${StyledEntityFollowButton} {
            margin-block-start: 12px;
          }

          ${Divider} {
            display: none;
          }

          ${StyledMyNewsPromotionWidget} {
            margin-block-start: 24px;
          }
        `;
    }
  }}
`;
